'use client'
import { authenticated } from '@/shared/permissions'
import { AuthRedirect } from '@/shared/components/auth-redirect'
import { PropsWithChildren } from 'react'

export default function Layout({ children }: Readonly<PropsWithChildren>) {
  if (authenticated()) return <AuthRedirect />

  return (
    <>
      <div className="px-5 py-5 flex justify-center items-center h-[100dvh] bg-gray">
        <div className="w-[472px]">{children}</div>
      </div>
    </>
  )
}
